import React from "react";
import { Box } from "@chakra-ui/react";
import { ChakraPath, ChakraSvg } from "ui/chakra-framer";

type TreeProps = {
  isStatic?: boolean;
  color: string;
};

export function Tree({ isStatic = false, color }: TreeProps) {
  const treePathProps = isStatic ? {} : { className: "tree-path", initial: { opacity: 0, pathLength: 0 } };
  const treeNodeProps = isStatic ? {} : { className: "tree-node", opacity: 0 };

  return (
    <Box
      pos="absolute"
      color={color}
      inset={0}
      top={{ base: "0", sm: "-24px", md: "-12px", lg: "-24px" }}
      w={{ base: "100%", sm: "82%", md: "98%", lg: "82%" }}
      mx="auto"
    >
      <ChakraSvg
        width="100%"
        h="auto"
        fill="none"
        viewBox="0 0 778 729"
        transition={isStatic ? "none" : "all .3s ease-in-out"}
      >
        <circle {...treeNodeProps} cx="20" cy="20" r="16" fill="currentColor" transform="matrix(-1 0 0 1 595 537)" />
        <ChakraPath
          {...treePathProps}
          stroke="currentColor"
          strokeWidth="4"
          d="M389 442v25c0 11.046 8.954 20 20 20h146c11.046 0 20 8.954 20 20v51"
        />
        <circle
          {...treeNodeProps}
          cx="20"
          cy="20"
          fill="currentColor"
          r="16"
          transform="matrix(-1 0 0 1 505 651.555)"
        />
        <ChakraPath
          {...treePathProps}
          stroke="currentColor"
          strokeWidth="4"
          d="M389 0v563.216c0 11.046 8.954 20 20 20h56c11.046 0 20 8.954 20 20v52.083"
        />
        <circle {...treeNodeProps} cx="20" cy="20" r="16" fill="currentColor" transform="matrix(-1 0 0 1 685 597)" />
        <ChakraPath
          {...treePathProps}
          stroke="currentColor"
          strokeWidth="4"
          d="M389 338v25c0 11.046 8.954 20 20 20h236c11.046 0 20 8.954 20 20v214"
        />
        <circle {...treeNodeProps} cx="20" cy="20" r="16" fill="currentColor" transform="matrix(-1 0 0 1 778 432)" />
        <ChakraPath
          {...treePathProps}
          stroke="currentColor"
          strokeWidth="4"
          d="M389 234v25c0 11.046 8.954 20 20 20h329c11.046 0 20 8.954 20 20v159"
        />
        <circle {...treeNodeProps} cx="203" cy="617" r="16" fill="currentColor" />
        <ChakraPath
          {...treePathProps}
          stroke="currentColor"
          strokeWidth="4"
          d="M389 392v25c0 11.046-8.954 20-20 20H223c-11.046 0-20 8.954-20 20v147"
        />
        <circle {...treeNodeProps} cx="112" cy="557" r="16" fill="currentColor" />
        <ChakraPath
          {...treePathProps}
          stroke="currentColor"
          strokeWidth="4"
          d="M389 288v25c0 11.046-8.954 20-20 20H133c-11.046 0-20 8.954-20 20v214"
        />
        <circle {...treeNodeProps} cx="20" cy="452" r="16" fill="currentColor" />
        <ChakraPath
          {...treePathProps}
          stroke="currentColor"
          strokeWidth="4"
          d="M389 184v25c0 11.046-8.954 20-20 20H40c-11.046 0-20 8.954-20 20v189"
        />
        <circle {...treeNodeProps} cx="10" cy="10" r="10" fill="currentColor" transform="matrix(-1 0 0 1 665 321)" />
        <ChakraPath
          {...treePathProps}
          stroke="currentColor"
          strokeWidth="4"
          d="M530 383h30c8.284 0 15-6.716 15-15v-22c0-8.284 6.716-15 15-15h56.5"
        />
        <circle {...treeNodeProps} cx="10" cy="10" r="10" fill="currentColor" transform="matrix(-1 0 0 1 575 425)" />
        <ChakraPath
          {...treePathProps}
          stroke="currentColor"
          strokeWidth="4"
          d="M440 487h30c8.284 0 15-6.716 15-15v-22c0-8.284 6.716-15 15-15h56.5"
        />
        <circle {...treeNodeProps} cx="213" cy="385" r="10" fill="currentColor" />
        <ChakraPath
          {...treePathProps}
          stroke="currentColor"
          strokeWidth="4"
          d="M338 437h-30c-8.284 0-15-6.716-15-15v-22c0-8.284-6.716-15-15-15h-56.5"
        />
        <circle {...treeNodeProps} cx="123" cy="281" r="10" fill="currentColor" />
        <ChakraPath
          {...treePathProps}
          stroke="currentColor"
          strokeWidth="4"
          d="M248 333h-30c-8.284 0-15-6.716-15-15v-22c0-8.284-6.716-15-15-15h-56.5"
        />
        <circle {...treeNodeProps} cx="10" cy="10" r="10" fill="currentColor" transform="matrix(-1 0 0 1 620 217)" />
        <ChakraPath
          {...treePathProps}
          stroke="currentColor"
          strokeWidth="4"
          d="M485 279h30c8.284 0 15-6.716 15-15v-22c0-8.284 6.716-15 15-15h56.5"
        />
        <circle {...treeNodeProps} cx="301" cy="537" r="10" fill="currentColor" />
        <ChakraPath
          {...treePathProps}
          stroke="currentColor"
          strokeWidth="4"
          d="M389 509v8.193c0 11.045-8.954 20-20 20h-60"
        />
      </ChakraSvg>
    </Box>
  );
}
